// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-box_content_box_section__xX22s {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.content-box_content_box__GAyeo {
    width: 100%;
    height: 170px;
    display: flex;
    flex-wrap: wrap;
    max-width: 170px;
    align-items: center;
    border-radius: 10px;
    justify-content: center;
    border: 1px solid #D6E5B8;
    background-color: #191A17;
}
.content-box_content_box__GAyeo p {
    margin: 0;
    font-size: 12px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 13px;
}
.content-box_view_all_text__fmFAM {
    font-size: 10px !important;
    margin-top: 3px !important;
    color: #AAFF00 !important;
}

.content-box_content_box_icon_box__kqNXl img {
    width: 100%;
    height: 55px;
    max-width: 55px;
}

.content-box_content_picture_box__0Xk6w {
    width: 100%;
    float: left;
    height: 70px;
    display: flex;
    max-width: 168px;
    overflow-x: auto;
    flex-wrap: nowrap;
    overflow-y: hidden;
    align-items: center;
    margin-bottom: 20px;
    justify-content: flex-start;
}
.content-box_content_picture_box__0Xk6w img {
    margin: 5px;
    width: 100%;
    height: 70px;
    flex-shrink: 0;
    max-width: 70px;
    border-radius: 5px;
}
.content-box_content_picture_box__0Xk6w video {
    margin: 5px;
    width: 100%;
    height: 70px;
    flex-shrink: 0;
    max-width: 70px;
    border-radius: 5px;
}

@media (min-width: 1200px) {
    .content-box_content_box_section__xX22s {
        display: flex;
        flex-wrap: wrap;
        margin-right: 0px;
        align-items: center;
        justify-content: flex-end;
    }
    .content-box_content_box__GAyeo {
        height: 300px;
        max-width: 300px;
        border-radius: 30px;
    }
    .content-box_content_box__GAyeo p {
        font-size: 20px;
        margin-left: 31px;
    }
    .content-box_view_all_text__fmFAM {
        font-size: 15px !important;
        margin-top: 6px !important;
    }

    .content-box_content_box_icon_box__kqNXl img {
        height: 80px;
        max-width: 80px;
    }

    .content-box_content_picture_box__0Xk6w {
        height: 150px;
        max-width: 298px;
        margin-bottom: 35px;
    }
    .content-box_content_picture_box__0Xk6w img {
        margin: 9px;
        height: 150px;
        max-width: 150px;
        border-radius: 10px;
    }
    .content-box_content_picture_box__0Xk6w video {
        margin: 9px;
        height: 150px;
        max-width: 150px;
        border-radius: 10px;
    }
}

.content-box_thumbMedia__bpj3f {
    width: 100%;
    cursor: pointer;
    border-radius: 8px;
}

.content-box_overlay__rVddM {
    position: fixed;   /* همین یک خط کم بود */
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,.8);
}

.content-box_fullscreenMedia__0f-nS {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 8px;
    object-fit: contain;
}

.content-box_galleryScroll__MP3Dk {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 92vw;
    max-height: 88vh;
    padding: 24px;
    /* ssmooth; */
}

.content-box_galleryItem__CMnqq {
    height: 78vh;
    width: auto;
    flex: 0 0 auto;
    object-fit: contain;
    border-radius: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/components/content-box/content-box.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe,IAAI,sBAAsB;IACzC,QAAQ;IACR,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".content_box_section {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.content_box {\r\n    width: 100%;\r\n    height: 170px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    max-width: 170px;\r\n    align-items: center;\r\n    border-radius: 10px;\r\n    justify-content: center;\r\n    border: 1px solid #D6E5B8;\r\n    background-color: #191A17;\r\n}\r\n.content_box p {\r\n    margin: 0;\r\n    font-size: 12px;\r\n    text-align: left;\r\n    color: #FFFFFF;\r\n    margin-left: 13px;\r\n}\r\n.view_all_text {\r\n    font-size: 10px !important;\r\n    margin-top: 3px !important;\r\n    color: #AAFF00 !important;\r\n}\r\n\r\n.content_box_icon_box img {\r\n    width: 100%;\r\n    height: 55px;\r\n    max-width: 55px;\r\n}\r\n\r\n.content_picture_box {\r\n    width: 100%;\r\n    float: left;\r\n    height: 70px;\r\n    display: flex;\r\n    max-width: 168px;\r\n    overflow-x: auto;\r\n    flex-wrap: nowrap;\r\n    overflow-y: hidden;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n    justify-content: flex-start;\r\n}\r\n.content_picture_box img {\r\n    margin: 5px;\r\n    width: 100%;\r\n    height: 70px;\r\n    flex-shrink: 0;\r\n    max-width: 70px;\r\n    border-radius: 5px;\r\n}\r\n.content_picture_box video {\r\n    margin: 5px;\r\n    width: 100%;\r\n    height: 70px;\r\n    flex-shrink: 0;\r\n    max-width: 70px;\r\n    border-radius: 5px;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .content_box_section {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        margin-right: 0px;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n    }\r\n    .content_box {\r\n        height: 300px;\r\n        max-width: 300px;\r\n        border-radius: 30px;\r\n    }\r\n    .content_box p {\r\n        font-size: 20px;\r\n        margin-left: 31px;\r\n    }\r\n    .view_all_text {\r\n        font-size: 15px !important;\r\n        margin-top: 6px !important;\r\n    }\r\n\r\n    .content_box_icon_box img {\r\n        height: 80px;\r\n        max-width: 80px;\r\n    }\r\n\r\n    .content_picture_box {\r\n        height: 150px;\r\n        max-width: 298px;\r\n        margin-bottom: 35px;\r\n    }\r\n    .content_picture_box img {\r\n        margin: 9px;\r\n        height: 150px;\r\n        max-width: 150px;\r\n        border-radius: 10px;\r\n    }\r\n    .content_picture_box video {\r\n        margin: 9px;\r\n        height: 150px;\r\n        max-width: 150px;\r\n        border-radius: 10px;\r\n    }\r\n}\r\n\r\n.thumbMedia {\r\n    width: 100%;\r\n    cursor: pointer;\r\n    border-radius: 8px;\r\n}\r\n\r\n.overlay {\r\n    position: fixed;   /* همین یک خط کم بود */\r\n    inset: 0;\r\n    z-index: 9999;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: rgba(0,0,0,.8);\r\n}\r\n\r\n.fullscreenMedia {\r\n    max-width: 90vw;\r\n    max-height: 90vh;\r\n    border-radius: 8px;\r\n    object-fit: contain;\r\n}\r\n\r\n.galleryScroll {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 20px;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n    max-width: 92vw;\r\n    max-height: 88vh;\r\n    padding: 24px;\r\n    /* ssmooth; */\r\n}\r\n\r\n.galleryItem {\r\n    height: 78vh;\r\n    width: auto;\r\n    flex: 0 0 auto;\r\n    object-fit: contain;\r\n    border-radius: 10px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_box_section": `content-box_content_box_section__xX22s`,
	"content_box": `content-box_content_box__GAyeo`,
	"view_all_text": `content-box_view_all_text__fmFAM`,
	"content_box_icon_box": `content-box_content_box_icon_box__kqNXl`,
	"content_picture_box": `content-box_content_picture_box__0Xk6w`,
	"thumbMedia": `content-box_thumbMedia__bpj3f`,
	"overlay": `content-box_overlay__rVddM`,
	"fullscreenMedia": `content-box_fullscreenMedia__0f-nS`,
	"galleryScroll": `content-box_galleryScroll__MP3Dk`,
	"galleryItem": `content-box_galleryItem__CMnqq`
};
export default ___CSS_LOADER_EXPORT___;
